import { render, staticRenderFns } from "./ResponsavelProcessamento.vue?vue&type=template&id=18777ac9&"
import script from "./ResponsavelProcessamento.vue?vue&type=script&lang=js&"
export * from "./ResponsavelProcessamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports